export class DattaConfig {
  static layout: string = 'vertical';
  static isCollapseMenu: boolean = false;
}
